// ─── Typography Token Pairs ───────────────────────────────────
// Each pair defines heading, body, and eyebrow fonts.
// Templates reference fontPair IDs, never raw font names.

export const fontPairs = {
  'playfair-inter': {
    id: 'playfair-inter',
    name: 'Classic Elegant',
    heading: "'Playfair Display', Georgia, serif",
    body: "'Inter', system-ui, sans-serif",
    eyebrow: "'Inter', system-ui, sans-serif",
  },
  'cormorant-manrope': {
    id: 'cormorant-manrope',
    name: 'Romantic Luxury',
    heading: "'Cormorant Garamond', Georgia, serif",
    body: "'Manrope', system-ui, sans-serif",
    eyebrow: "'Manrope', system-ui, sans-serif",
  },
  'dmserif-plusjakarta': {
    id: 'dmserif-plusjakarta',
    name: 'Modern Refined',
    heading: "'DM Serif Display', Georgia, serif",
    body: "'Plus Jakarta Sans', system-ui, sans-serif",
    eyebrow: "'Plus Jakarta Sans', system-ui, sans-serif",
  },
};

// ─── Typography Scale ─────────────────────────────────────────
// Mobile-first sizes. Desktop overrides applied via media query.

export const typeScale = {
  eyebrow:   { size: '0.75rem',  lineHeight: '1rem',   letterSpacing: '0.12em', weight: 500 },
  bodySm:    { size: '0.875rem', lineHeight: '1.4rem', letterSpacing: '0',      weight: 400 },
  body:      { size: '1rem',     lineHeight: '1.7rem', letterSpacing: '0',      weight: 400 },
  bodyLg:    { size: '1.125rem', lineHeight: '1.9rem', letterSpacing: '0',      weight: 400 },
  headingSm: { size: '1.5rem',   lineHeight: '1.9rem', letterSpacing: '-0.01em', weight: 600 },
  headingMd: { size: '2rem',     lineHeight: '2.3rem', letterSpacing: '-0.01em', weight: 600 },
  headingLg: { size: '2.75rem',  lineHeight: '3rem',   letterSpacing: '-0.02em', weight: 600 },
  hero:      { size: '3.5rem',   lineHeight: '3.8rem', letterSpacing: '-0.02em', weight: 600 },
};

// Desktop overrides (applied at ≥768px)
export const typeScaleDesktop = {
  headingMd: { size: '2.5rem' },
  headingLg: { size: '4rem' },
  hero:      { size: '5.5rem' },
};
